<template lang="pug">
ValidationProvider(
  :name='$attrs.name',
  :rules='$attrs.rules'
  :debounce="$attrs.debounce || 400"
  v-slot='{ passed, failed, errors }')
  md-field(
    :class='[{ "md-error md-invalid": failed }, { "md-valid": passed }, { "mt-0": !hasLabel }]')
    label
      slot(name='label')
    md-input(v-bind='$attrs' v-on='$listeners')
    slide-y-down-transition
      .md-error {{ errors.join("\n") }}
    slide-y-down-transition
      md-icon.error(v-show='failed') close
    slide-y-down-transition
      md-icon.success(v-show='passed') done
</template>

<script>
export default {
  name: 'ValidatedInput',
  inheritAttrs: false,
  computed: {
    hasLabel () {
      return !!this.$slots['label']
    }
  }
}
</script>

<style scoped>
.md-field > .md-error {
  bottom: -10px;
}
.mt-0 {
  margin-top: 0;
}
</style>
